/* eslint-disable */
import * as util from "@/api/order";

const state = {
    paymentArr: {
        "id": "",
        "network_id": 0,
        "invoice_header_id": "",
        "total_bill": 0,
        "payment_type": "",
        "token": "",
        "redirect_url": "",
        "status": 0,
        "create_datetime": "",
        "update_datetime": ""
    },
    invoiceDetail: [],
    invoiceArr: {
        "id": "",
        "network_id": 0,
        "code": "",
        "status": "",
        "total_gross": 0,
        "total_discount_rupiah": 0,
        "total_nett": 0,
        "kode_unik": 0,
        "total_bill": 0,
        "expire_datetime": "",
        "create_datetime": "",
        "update_datetime": ""
    },
    shoppingCartArr: {
        "activation_days": 0,
        "category_id": "",
        "code": "",
        "description": "",
        "discount_rupiah": 0,
        "id": 0,
        "name": "",
        "package": "",
        "price_gross": 0,
        "price_nett": 0
    },
    emptyShoppingCartArr: {
        "activation_days": 0,
        "category_id": "",
        "code": "",
        "description": "",
        "discount_rupiah": 0,
        "id": 0,
        "name": "",
        "package": "",
        "price_gross": 0,
        "price_nett": 0
    }
};

const mutations = {
    SET_paymentArr: (state, value) => {
        state.paymentArr = value
    },
    SET_invoiceArr: (state, value) => {
        state.invoiceArr = value
    },
    SET_invoiceDetail: (state, value) => {
        state.invoiceDetail = value
    },
    SET_shoppingCartArr: (state, value) => {
        state.shoppingCartArr = value
    }
};

const actions = {
    extendLicense({ commit }, param) {
        return new Promise((resolve, reject) => {
            util.extendLicense(param).then(response => {
                // const { data } = response;
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getActiveVoucher({ commit }, param) {
        return new Promise((resolve, reject) => {
            util.getActiveVoucher(param).then(response => {
                // const { data } = response;
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    voucherList({ commit }, param) {
        return new Promise((resolve, reject) => {
            util.voucherList(param).then(response => {
                // const { data } = response;
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    orderList({ commit }, param) {
        return new Promise((resolve, reject) => {
            util.orderList(param).then(response => {
                // const { data } = response;
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    selectPayment({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.selectPayment(dataParams).then(response => {
                const { data } = response;
                commit('SET_invoiceArr', data)
                resolve(data);
            }).catch(error => {
                reject(error);
            });
        });
    },
    destroyShoppingCart({ commit }) {
        commit('SET_shoppingCartArr', null)
    },
    updateShoppingCart({ commit }, data) {
        commit('SET_shoppingCartArr', data)
    },
    getInvoice({ commit }, param) {
        return new Promise((resolve, reject) => {
            util.getInvoice(param).then(response => {
                const { data } = response;
                commit('SET_invoiceArr', data.invoice)
                commit('SET_paymentArr', data.payment)
                commit('SET_invoiceDetail', data.detail)
                resolve(data);
            }).catch(error => {
                reject(error);
            });
        });
    },
    createOrder({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.createOrder(dataParams).then(response => {
                const { data } = response;
                commit('SET_invoiceArr', data)
                resolve(data);
            }).catch(error => {
                reject(error);
            });
        });
    },
    createPayment({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.createPayment(dataParams).then(response => {
                const { data } = response;
                commit('SET_invoiceArr', data.invoice)
                commit('SET_paymentArr', data.payment)
                resolve(data);
            }).catch(error => {
                reject(error);
            });
        });
    },
};


export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/order.js